export const websiteConfig = {
  origin: process.env.VUE_APP_WEBSITE_ORIGIN || 'https://profiteia.io',
  noindex: process.env.VUE_APP_WEBSITE_NOINDEX === 'true',
  scrumbleOrigin: process.env.VUE_APP_SCRUMBLE_API_URL || 'https://auth.profiteia.io',
  apiOrigin: process.env.VUE_APP_WEBSITE_API_ORIGIN || 'https://api.profiteia.io',
  portalOrigin: process.env.VUE_APP_WEBSITE_PORTAL_ORIGIN || 'https://portal.profiteia.io',
};
export const portalHref = (path = '/') => `${websiteConfig.portalOrigin}/#${path}`;

export const privacyUrl = 'https://profiteiawd20b85c8a3.blob.core.windows.net/blobprofiteiawd20b85c8a3/wp-content/uploads/2025/06/Privacyverklaring-Profiteia.pdf';

export const portalDemoHref = (kind) =>
  portalHref(
    kind
      ? `/tools/${kind === 'shadow' ? 'shadow-trading' : 'bidding-strategy'}/new?demo=1`
      : '/?demo=1'
  );

export const demoBookingHref = 'https://bookings.cloud.microsoft/bookwithme/user/256ca66a34dd47a0a0863771f79a979a@profiteia.io?anonymous&ismsaljsauthenabled&ep=pcard';

/** Which conversion a website link leads to (marketing plan §5.6 `cta_id`), or null. */
/** A kennisbank CTA card's button: `kb:` + the bundle, tool or dataset page it leads to, without locale. */
export function kennisbankCtaId(link) {
  if (!link?.closest?.('.website-editorial-action')) return null;
  const target = new URL(link.href, websiteConfig.origin);
  return `kb:${target.pathname.replace(/^\/(?:en|de|fr)(?=\/)/, '')}${target.hash}`;
}
export function websiteCtaId(href, portalOrigin = websiteConfig.portalOrigin) {
  if (href.startsWith(demoBookingHref.split('?')[0])) return 'book_demo';
  if (href.startsWith('mailto:')) return 'email';
  if (!href.startsWith(portalOrigin)) return null;
  if (href.includes('demo=1')) return 'try_demo';
  for (const [route, id] of [['#/register', 'register'], ['#/login', 'login'], ['#/subscriptions', 'plans'], ['#/api-docs', 'api_docs']]) {
    if (href.includes(route)) return id;
  }
  return 'portal';
}
